import * as React from 'react';
import { Box, CssBaseline } from '@mui/material';
import AppLayout from './AppLayout/NavBar';

const Layout = () => {
  return (
    <Box>
      <CssBaseline />
      <AppLayout />
    </Box>
  );
};

export default Layout;
